import getConfig from 'next/config'

export const fetchGet = async(path: string, query: URLSearchParams | null = null) => {

    const { serverRuntimeConfig, _ } = getConfig()
    const start = new Date();

    let uri = (serverRuntimeConfig.flexiInternalUrl) + '/api' + path;
    uri = uri + (query ?  '?' + query.toString() : '')

    const response = await fetch(uri, {
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Basic ' + serverRuntimeConfig.flexiToken
        },
        cache: 'force-cache'
    });

    console.log(`${start.toLocaleDateString()} ${start.toLocaleTimeString()} FETCH GET ${uri} response time: ${(new Date().getTime()) - start.getTime()}ms`);
    if(!response.headers.get('content-type')?.includes('json'))
    {
        throw new Error('Unknown error upon fetching ' + path)
    }

    const data = await response.json();
    if(!response.ok)
    {
        console.error(data);
        throw new Error();
    }

    return data;
}

export const fetchPost = async(path: string, body: ArrayBuffer | string | object = {}) => {

    const { _, publicRuntimeConfig } = getConfig()

        const start = new Date();
        const uri = publicRuntimeConfig.flexiExternalUrl + '/api' + path;
        const response = await fetch(uri, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + publicRuntimeConfig.flexiToken,
                'X-Requested-With': 'XmlHttpRequest'
            },
            body: JSON.stringify(body),
        });

        console.log(`${start.toLocaleDateString()} ${start.toLocaleTimeString()} FETCH POST ${uri} response time: ${(new Date().getTime()) - start.getTime()}ms`);
        if(!response.headers.get('content-type')?.includes('json') && !response.ok)
        {
            throw new Error('Unknown error upon posting to ' + path)
        }

        const data = await response.json();
        if(!response.ok)
        {
            console.error(data);
            throw new Error();
        }

        return data;
}
